import _regeneratorRuntime from "/home/circleci/repo/front/node_modules/react-scripts/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/home/circleci/repo/front/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/repo/front/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e16) { throw _e16; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e17) { didErr = true; err = _e17; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*!
 * Dynamsoft JavaScript Library
 * @product Dynamsoft Camera Enhancer JS Edition
 * @website http://www.dynamsoft.com
 * @copyright Copyright 2021, Dynamsoft Corporation
 * @author Dynamsoft
 * @version 2.0.3 (js 20210628)
 * @fileoverview Dynamsoft JavaScript Library for Camera Enhancer
 * More info on DBR JS: https://www.dynamsoft.com/barcode-reader/sdk-javascript/
 */
function e(e, t, i, s) {
  return new (i || (i = Promise))(function (o, n) {
    function r(e) {
      try {
        h(s.next(e));
      } catch (e) {
        n(e);
      }
    }

    function a(e) {
      try {
        h(s.throw(e));
      } catch (e) {
        n(e);
      }
    }

    function h(e) {
      var t;
      e.done ? o(e.value) : (t = e.value, t instanceof i ? t : new i(function (e) {
        e(t);
      })).then(r, a);
    }

    h((s = s.apply(e, t || [])).next());
  });
}

var t = !!("object" == typeof global && global.process && global.process.release && global.process.release.name && "undefined" == typeof HTMLCanvasElement),
    i = !t && "undefined" == typeof self;

var s = /*#__PURE__*/function () {
  function s() {
    var _this = this;

    _classCallCheck(this, s);

    this._canvasMaxWH = "iPhone" == s.browserInfo.OS || "Android" == s.browserInfo.OS ? 2048 : 4096, this._singleFrameMode = !(navigator && navigator.mediaDevices && navigator.mediaDevices.getUserMedia), this._singleFrameModeIpt = function () {
      var t = document.createElement("input");
      return t.setAttribute("type", "file"), t.setAttribute("accept", "image/*"), t.setAttribute("capture", ""), t.addEventListener("change", function () {
        return e(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var e;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  e = t.files[0];
                  t.value = "", this.onSingleFrameAcquired(e);

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
      }), t;
    }, this._clickIptSingleFrameMode = function () {
      _this._singleFrameModeIpt().click();
    }, this.styleEls = [], this.bSaveOriCanvas = !0, this.maxVideoCvsLength = 3, this.videoCvses = [], this.videoGlCvs = null, this.videoGl = null, this.glImgData = null, this._onCameraSelChange = function () {
      _this.play(_this._selCam.value).then(function () {
        _this._isOpen || _this.stop();
      });
    }, this._onResolutionSelChange = function () {
      var e, t;

      if (_this._selRsl && -1 != _this._selRsl.selectedIndex) {
        var _i = _this._selRsl.options[_this._selRsl.selectedIndex];
        e = _i.getAttribute("data-width"), t = _i.getAttribute("data-height");
      }

      _this.play(void 0, e, t).then(function () {
        _this._isOpen || _this.stop();
      });
    }, this._onCloseBtnClick = function () {
      _this.close();
    }, this._isOpen = !1, this.videoSettings = {
      video: {
        width: {
          ideal: 1280
        },
        height: {
          ideal: 720
        },
        facingMode: {
          ideal: "environment"
        }
      }
    }, this.iPlayRound = 0, this.promisePlay = null, this._allCameras = [], this._currentCamera = null, this._videoTrack = null, this._lastDeviceId = void 0, this._vc_bPlayingVideoBeforeHide = !1, this._ev_documentHideEvent = function () {
      "visible" === document.visibilityState ? _this._vc_bPlayingVideoBeforeHide && ("Firefox" == s.browserInfo.browser ? _this.play() : _this._video.play(), _this._vc_bPlayingVideoBeforeHide = !1) : _this._video && !_this._video.paused && (_this._vc_bPlayingVideoBeforeHide = !0, _this._video.pause());
    }, this._video = null, this._bgLoading = null, this._selCam = null, this._bgCamera = null, this._selRsl = null, this._optGotRsl = null, this._btnClose = null, this._region = null, this.bChangeRegionIndexManually = !1, this._regionIndex = -1, this._loopInterval = 0, this._frameQueueMaxLength = 1, this._frameQueue = [], this._bFetchingLoopStarted = !1, this._bStoppedByPause = !1, this.alwaysRefreshBuffer = !0, this._bufferRefreshInterval = 0, this.bDestroyed = !1;
  }

  _createClass(s, [{
    key: "getUIElement",
    value: function getUIElement() {
      return this.UIElement;
    }
  }, {
    key: "setUIElement",
    value: function setUIElement(t) {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _e2, _e, _t, _i2;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!("string" == typeof t || t instanceof String)) {
                  _context2.next = 16;
                  break;
                }

                if (t.trim().startsWith("<")) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 4;
                return fetch(t);

              case 4:
                _e2 = _context2.sent;

                if (_e2.ok) {
                  _context2.next = 7;
                  break;
                }

                throw Error("setUIElement(elementOrUrl): Network Error: " + _e2.statusText);

              case 7:
                _context2.next = 9;
                return _e2.text();

              case 9:
                t = _context2.sent;

              case 10:
                if (t.trim().startsWith("<")) {
                  _context2.next = 12;
                  break;
                }

                throw Error("setUIElement(elementOrUrl): Can't get valid HTMLElement.");

              case 12:
                _e = document.createElement("div");
                _e.innerHTML = t;

                for (_t = 0; _t < _e.childElementCount; ++_t) {
                  _i2 = _e.children[_t];
                  _i2 instanceof HTMLStyleElement && (this.styleEls.push(_i2), document.head.append(_i2));
                }

                (t = 1 == _e.childElementCount ? _e.children[0] : _e).remove();

              case 16:
                this.UIElement = t;

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "_bindUI",
    value: function _bindUI() {
      if (!this.UIElement) throw new Error("Need to define `UIElement` before opening.");
      var e = [this.UIElement],
          t = this.UIElement.children;

      var _iterator = _createForOfIteratorHelper(t),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _i5 = _step.value;
          e.push(_i5);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      for (var _t2 = 0; _t2 < e.length; ++_t2) {
        var _iterator2 = _createForOfIteratorHelper(e[_t2].children),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _i3 = _step2.value;
            e.push(_i3);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      var i = null;

      for (var _i4 = 0, _e3 = e; _i4 < _e3.length; _i4++) {
        var _t3 = _e3[_i4];
        !this._video && _t3.classList.contains("dce-video") ? (this._video = _t3, this._video.setAttribute("playsinline", "true")) : !this._bgLoading && _t3.classList.contains("dce-bg-loading") ? this._bgLoading = _t3 : !this._bgCamera && _t3.classList.contains("dce-bg-camera") ? this._bgCamera = _t3 : !this._selCam && _t3.classList.contains("dce-sel-camera") ? this._selCam = _t3 : !this._selRsl && _t3.classList.contains("dce-sel-resolution") ? (this._selRsl = _t3, this._selRsl.options.length || (this._selRsl.innerHTML = [this._optGotRsl ? "" : '<option class="dce-opt-gotResolution" value="got"></option>', '<option data-width="1920" data-height="1080">ask 1920 x 1080</option>', '<option data-width="1280" data-height="720">ask 1280 x 720</option>', '<option data-width="640" data-height="480">ask 640 x 480</option>'].join(""), this._optGotRsl = this._optGotRsl || this._selRsl.options[0])) : !this._optGotRsl && _t3.classList.contains("dce-opt-gotResolution") ? this._optGotRsl = _t3 : !this._btnClose && _t3.classList.contains("dce-btn-close") ? this._btnClose = _t3 : !this._video && _t3.classList.contains("dce-existingVideo") ? (this._video = _t3, this._video.setAttribute("playsinline", "true")) : !i && _t3.tagName && "video" == _t3.tagName.toLowerCase() && (i = _t3);
      }

      if (!this._video && i && (this._video = i), this.singleFrameMode ? this._video && (this._video.addEventListener("click", this._clickIptSingleFrameMode), this._video.style.cursor = "pointer", this._video.setAttribute("title", "Take a photo")) : this._bgLoading && (this._bgLoading.style.display = ""), this.singleFrameMode ? (this._video && (this._video.addEventListener("click", this._clickIptSingleFrameMode), this._video.style.cursor = "pointer", this._video.setAttribute("title", "Take a photo")), this._bgCamera && (this._bgCamera.style.display = "")) : this._bgLoading && (this._bgLoading.style.display = ""), this._selCam && this._selCam.addEventListener("change", this._onCameraSelChange), this._selRsl && this._selRsl.addEventListener("change", this._onResolutionSelChange), this._btnClose && this._btnClose.addEventListener("click", this._onCloseBtnClick), !this._video) throw this._unbindUI(), Error("Can not find HTMLVideoElement with class `dce-video`");
      this._isOpen = !0;
    }
  }, {
    key: "_unbindUI",
    value: function _unbindUI() {
      this.singleFrameMode ? (this._video && (this._video.removeEventListener("click", this._clickIptSingleFrameMode), this._video.style.cursor = "", this._video.removeAttribute("title")), this._bgCamera && (this._bgCamera.style.display = "none")) : this._bgLoading && (this._bgLoading.style.display = "none"), this._selCam && this._selCam.removeEventListener("change", this._onCameraSelChange), this._selRsl && this._selRsl.removeEventListener("change", this._onResolutionSelChange), this._btnClose && this._btnClose.removeEventListener("click", this._onCloseBtnClick), this._video = null, this._selCam = null, this._selRsl = null, this._optGotRsl = null, this._btnClose = null, this._isOpen = !1;
    }
  }, {
    key: "_assertOpen",
    value: function _assertOpen() {
      if (!this._isOpen) throw Error("The camera is not open.");
    }
  }, {
    key: "isContextDestroyed",
    value: function isContextDestroyed() {
      return this.bDestroyed;
    }
  }, {
    key: "play",
    value: function play(t, i, o) {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _this2 = this;

        var _t4, n;

        return _regeneratorRuntime.wrap(function _callee8$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(this._assertOpen(), this._video && this.videoSrc)) {
                  _context9.next = 5;
                  break;
                }

                _context9.next = 3;
                return new Promise(function (t, i) {
                  _this2._video.onloadedmetadata = function () {
                    return e(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              this._video.onloadedmetadata = null;
                              _context3.next = 3;
                              return this._video.play();

                            case 3:
                              t();

                            case 4:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3, this);
                    }));
                  }, "string" == typeof _this2.videoSrc || _this2.videoSrc instanceof String ? _this2._video.src = _this2.videoSrc : _this2._video.srcObject = _this2.videoSrc, setTimeout(function () {
                    return i(new Error("Failed to play video. Timeout."));
                  }, 4e3);
                });

              case 3:
                _t4 = {
                  width: this._video.videoWidth,
                  height: this._video.videoHeight
                };
                return _context9.abrupt("return", (this.onPlayed && setTimeout(function () {
                  _this2.onPlayed(_t4);
                }, 0), _t4));

              case 5:
                if (!this.singleFrameMode) {
                  _context9.next = 7;
                  break;
                }

                return _context9.abrupt("return", (this._clickIptSingleFrameMode(), {
                  width: 0,
                  height: 0
                }));

              case 7:
                n = ++this.iPlayRound;
                _context9.t0 = this.promisePlay;

                if (!_context9.t0) {
                  _context9.next = 13;
                  break;
                }

                _context9.next = 12;
                return this.promisePlay;

              case 12:
                _context9.t0 = n < this.iPlayRound;

              case 13:
                if (!_context9.t0) {
                  _context9.next = 17;
                  break;
                }

                _context9.t1 = {
                  width: this._video.videoWidth,
                  height: this._video.videoHeight
                };
                _context9.next = 21;
                break;

              case 17:
                this.promisePlay = function () {
                  return e(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                    var _this3 = this;

                    var n, r, a, h, d, l, g, _e4, c, u, _, v, m, f, _e8, _t5, p, b, y;

                    return _regeneratorRuntime.wrap(function _callee7$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            _context8.prev = 0;
                            this._video && this._video.srcObject && this.stop();
                            s._onLog && s._onLog("DCE: ======before video========");
                            _context8.next = 5;
                            return this.getAllCameras();

                          case 5:
                            r = function r() {
                              if (_this3.bDestroyed) throw l && l.getTracks().forEach(function (e) {
                                e.stop();
                              }), _this3._video.srcObject = null, _this3._videoTrack = null, _this3._currentCamera = null, new Error("The CameraEnhancer instance has been destroyed.");
                            };

                            a = JSON.parse(JSON.stringify(this.videoSettings));
                            "boolean" == typeof a.video && (a.video = {}), i && (a.video.width = {
                              ideal: i
                            }), o && (a.video.height = {
                              ideal: o
                            });
                            d = ["rear", "back", "rück", "arrière", "trasera", "trás", "traseira", "posteriore", "后面", "後面", "背面", "后置", "後置", "背置", "задней", "الخلفية", "후", "arka", "achterzijde", "หลัง", "baksidan", "bagside", "sau", "bak", "tylny", "takakamera", "belakang", "אחורית", "πίσω", "spate", "hátsó", "zadní", "darrere", "zadná", "задня", "stražnja", "belakang", "बैक"];

                            g = function g() {
                              var _iterator3 = _createForOfIteratorHelper(_this3._allCameras),
                                  _step3;

                              try {
                                var _loop = function _loop() {
                                  var e = _step3.value;
                                  var t = e.label.toLowerCase();

                                  if (t && d.some(function (e) {
                                    return -1 != t.indexOf(e);
                                  }) && /\b0(\b)?/.test(t)) {
                                    delete a.video.facingMode, a.video.deviceId = {
                                      ideal: e.deviceId
                                    };
                                    return "break";
                                  }
                                };

                                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                                  var _ret = _loop();

                                  if (_ret === "break") break;
                                }
                              } catch (err) {
                                _iterator3.e(err);
                              } finally {
                                _iterator3.f();
                              }

                              a.video.deviceId || -1 == ["Android", "HarmonyOS"].indexOf(s.browserInfo.OS) || (delete a.video.facingMode, a.video.deviceId = {
                                ideal: _this3._allCameras[_this3._allCameras.length - 1].deviceId
                              });
                            };

                            if (t) delete a.video.facingMode, a.video.deviceId = {
                              exact: t
                            }, this._lastDeviceId = t;else if (a.video.deviceId) ;else if (this._lastDeviceId) delete a.video.facingMode, a.video.deviceId = {
                              exact: this._lastDeviceId
                            };else if (a.video.facingMode) {
                              _e4 = a.video.facingMode;
                              _e4 instanceof Array && _e4.length && (_e4 = _e4[0]), _e4 = _e4.exact || _e4.ideal || _e4, "environment" === _e4 && (h = !!a.video.facingMode, g());
                            }
                            s._onLog && s._onLog("DCE: ======try getUserMedia========");
                            u = [0, 500], _ = null, v = null, m = function m(t) {
                              return e(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                                var _iterator4, _step4, _loop2, _ret2;

                                return _regeneratorRuntime.wrap(function _callee4$(_context5) {
                                  while (1) {
                                    switch (_context5.prev = _context5.next) {
                                      case 0:
                                        _iterator4 = _createForOfIteratorHelper(u);
                                        _context5.prev = 1;
                                        _loop2 = /*#__PURE__*/_regeneratorRuntime.mark(function _loop2() {
                                          var e, _e5;

                                          return _regeneratorRuntime.wrap(function _loop2$(_context4) {
                                            while (1) {
                                              switch (_context4.prev = _context4.next) {
                                                case 0:
                                                  e = _step4.value;
                                                  r();
                                                  _context4.t0 = e;

                                                  if (!_context4.t0) {
                                                    _context4.next = 6;
                                                    break;
                                                  }

                                                  _context4.next = 6;
                                                  return new Promise(function (t) {
                                                    return setTimeout(t, e);
                                                  });

                                                case 6:
                                                  r();
                                                  _e5 = t.video.deviceId;
                                                  v = _e5 ? _e5.exact || _e5.ideal || _e5 : null;
                                                  _context4.prev = 9;
                                                  s._onLog && s._onLog("DCE: ask " + JSON.stringify(t));
                                                  _context4.next = 13;
                                                  return navigator.mediaDevices.getUserMedia(t);

                                                case 13:
                                                  l = _context4.sent;
                                                  return _context4.abrupt("return", "break");

                                                case 17:
                                                  _context4.prev = 17;
                                                  _context4.t1 = _context4["catch"](9);
                                                  _ = _context4.t1, s._onLog && s._onLog("DCE: " + _context4.t1.message || _context4.t1);

                                                case 20:
                                                case "end":
                                                  return _context4.stop();
                                              }
                                            }
                                          }, _loop2, null, [[9, 17]]);
                                        });

                                        _iterator4.s();

                                      case 4:
                                        if ((_step4 = _iterator4.n()).done) {
                                          _context5.next = 11;
                                          break;
                                        }

                                        return _context5.delegateYield(_loop2(), "t0", 6);

                                      case 6:
                                        _ret2 = _context5.t0;

                                        if (!(_ret2 === "break")) {
                                          _context5.next = 9;
                                          break;
                                        }

                                        return _context5.abrupt("break", 11);

                                      case 9:
                                        _context5.next = 4;
                                        break;

                                      case 11:
                                        _context5.next = 16;
                                        break;

                                      case 13:
                                        _context5.prev = 13;
                                        _context5.t1 = _context5["catch"](1);

                                        _iterator4.e(_context5.t1);

                                      case 16:
                                        _context5.prev = 16;

                                        _iterator4.f();

                                        return _context5.finish(16);

                                      case 19:
                                      case "end":
                                        return _context5.stop();
                                    }
                                  }
                                }, _callee4, null, [[1, 13, 16, 19]]);
                              }));
                            };
                            _context8.next = 15;
                            return m(a);

                          case 15:
                            if (l) {
                              _context8.next = 20;
                              break;
                            }

                            if (s._onLog && s._onLog("DCE: ======try getUserMedia again========"), c = JSON.parse(JSON.stringify(a)), "object" == typeof c.video) {
                              "iPhone" == s.browserInfo.OS ? (i >= 1280 || o >= 1280 ? c.video.width = 1280 : i >= 640 || o >= 640 ? c.video.width = 640 : (i < 640 || o < 640) && (c.video.width = 320), delete c.video.height) : h && !a.video.deviceId ? (delete c.video.facingMode, this._allCameras.length && (c.video.deviceId = {
                                ideal: this._allCameras[this._allCameras.length - 1].deviceId
                              })) : c.video = !0;
                            }

                            s._onLog && s._onLog("DCE: " + c);
                            _context8.next = 20;
                            return m(c);

                          case 20:
                            _context8.t0 = l;

                            if (_context8.t0) {
                              _context8.next = 25;
                              break;
                            }

                            u = [1e3, 2e3];
                            _context8.next = 25;
                            return m(a);

                          case 25:
                            _context8.t1 = l;

                            if (_context8.t1) {
                              _context8.next = 29;
                              break;
                            }

                            _context8.next = 29;
                            return m(c);

                          case 29:
                            if (l) {
                              _context8.next = 31;
                              break;
                            }

                            throw _;

                          case 31:
                            f = function f() {
                              var e = l.getVideoTracks();
                              var t, i;

                              if (e.length && (t = _this3._videoTrack = e[0]), _this3._video && t) {
                                if (t.label) {
                                  var _iterator5 = _createForOfIteratorHelper(_this3._allCameras),
                                      _step5;

                                  try {
                                    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                                      var _e6 = _step5.value;

                                      if (t.label == _e6.label) {
                                        _e6._checked = !0, i = _e6, _this3._lastDeviceId = _e6.deviceId;
                                        break;
                                      }
                                    }
                                  } catch (err) {
                                    _iterator5.e(err);
                                  } finally {
                                    _iterator5.f();
                                  }
                                }

                                if (!i && v) {
                                  var _iterator6 = _createForOfIteratorHelper(_this3._allCameras),
                                      _step6;

                                  try {
                                    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                                      var _e7 = _step6.value;

                                      if (v == _e7.deviceId) {
                                        t.label && (_e7._checked = !0, _e7.label = t.label), i = _e7, _this3._lastDeviceId = _e7.deviceId;
                                        break;
                                      }
                                    }
                                  } catch (err) {
                                    _iterator6.e(err);
                                  } finally {
                                    _iterator6.f();
                                  }
                                }
                              }

                              _this3._currentCamera = i;
                            };

                            _context8.next = 34;
                            return this.getAllCameras();

                          case 34:
                            r();

                            if (!h) {
                              _context8.next = 46;
                              break;
                            }

                            f(), g();
                            _e8 = a.video.deviceId;
                            _e8 && (_e8 = _e8.exact || _e8.ideal || _e8);
                            _t5 = null === (n = this._currentCamera) || void 0 === n ? void 0 : n.deviceId;
                            _context8.t2 = !_e8 || _t5 && _e8 == _t5;

                            if (_context8.t2) {
                              _context8.next = 46;
                              break;
                            }

                            l.getTracks().forEach(function (e) {
                              e.stop();
                            });
                            u = [0, 500, 1e3, 2e3];
                            _context8.next = 46;
                            return m(a);

                          case 46:
                            r();

                            p = function p() {
                              return e(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                                var _this4 = this;

                                return _regeneratorRuntime.wrap(function _callee6$(_context7) {
                                  while (1) {
                                    switch (_context7.prev = _context7.next) {
                                      case 0:
                                        s._onLog && s._onLog("======play video========");
                                        _context7.next = 3;
                                        return new Promise(function (t, i) {
                                          _this4._video.onloadedmetadata = function () {
                                            return e(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                                              return _regeneratorRuntime.wrap(function _callee5$(_context6) {
                                                while (1) {
                                                  switch (_context6.prev = _context6.next) {
                                                    case 0:
                                                      this._video.onloadedmetadata = null;
                                                      _context6.next = 3;
                                                      return this._video.play();

                                                    case 3:
                                                      t();

                                                    case 4:
                                                    case "end":
                                                      return _context6.stop();
                                                  }
                                                }
                                              }, _callee5, this);
                                            }));
                                          }, _this4._video.srcObject = l, setTimeout(function () {
                                            return i(new Error("Failed to play video. Timeout."));
                                          }, 4e3);
                                        });

                                      case 3:
                                      case "end":
                                        return _context7.stop();
                                    }
                                  }
                                }, _callee6);
                              }));
                            };

                            _context8.next = 50;
                            return p();

                          case 50:
                            s._onLog && s._onLog("DCE: ======played video========");
                            this._bgLoading && (this._bgLoading.style.animationPlayState = "paused");
                            b = "got " + this._video.videoWidth + "x" + this._video.videoHeight;
                            this._optGotRsl && (this._optGotRsl.setAttribute("data-width", this._video.videoWidth), this._optGotRsl.setAttribute("data-height", this._video.videoHeight), this._optGotRsl.innerText = b, this._selRsl && this._optGotRsl.parentNode == this._selRsl && (this._selRsl.value = "got")), s._onLog && s._onLog("DCE: " + b), f(), r(), this._renderSelCameraInfo();
                            y = {
                              width: this._video.videoWidth,
                              height: this._video.videoHeight
                            };
                            return _context8.abrupt("return", (this.onPlayed && setTimeout(function () {
                              _this3.onPlayed(y);
                            }, 0), this.promisePlay = null, y));

                          case 58:
                            _context8.prev = 58;
                            _context8.t3 = _context8["catch"](0);
                            throw this.promisePlay = null, _context8.t3;

                          case 61:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee7, this, [[0, 58]]);
                  }));
                }();

                _context9.next = 20;
                return this.promisePlay;

              case 20:
                _context9.t1 = _context9.sent;

              case 21:
                return _context9.abrupt("return", _context9.t1);

              case 22:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "resume",
    value: function resume() {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.play();

              case 2:
                this._bStoppedByPause && (this._bStoppedByPause = !1, this.startFetchingLoop());

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "pause",
    value: function pause() {
      this._video && this._video.pause(), this._bFetchingLoopStarted && (this.stopFetchingLoop(), this._bStoppedByPause = !0);
    }
  }, {
    key: "close",
    value: function close() {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this.stop(), this._unbindUI(), this.UIElement.style.display = "none", this.stopFetchingLoop();

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "open",
    value: function open() {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this._bindUI();

                this.UIElement.parentNode || (this.UIElement.style.position = "fixed", this.UIElement.style.left = "0", this.UIElement.style.top = "0", document.body.append(this.UIElement));
                "none" == this.UIElement.style.display && (this.UIElement.style.display = "");
                _context12.next = 5;
                return this.play();

              case 5:
                return _context12.abrupt("return", _context12.sent);

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "stop",
    value: function stop() {
      this._video && this._video.srcObject && (s._onLog && s._onLog("DCE: ======stop video========"), this._video.srcObject.getTracks().forEach(function (e) {
        e.stop();
      }), this._video.srcObject = null, this._videoTrack = null, this._currentCamera = null), this._video && this._video.classList.contains("dce-existingVideo") && (s._onLog && s._onLog("DCE: ======stop existing video========"), this._video.pause(), this._video.currentTime = 0), this._bgLoading && (this._bgLoading.style.animationPlayState = ""), this._frameQueue.length = 0;
    }
  }, {
    key: "getAllCameras",
    value: function getAllCameras() {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var e, t, i, _iterator7, _step7, _e9, _s, _o, n, _iterator8, _step8, _e10;

        return _regeneratorRuntime.wrap(function _callee12$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return navigator.mediaDevices.enumerateDevices();

              case 2:
                e = _context13.sent;
                t = [];
                i = [];

                if (this._allCameras) {
                  _iterator7 = _createForOfIteratorHelper(this._allCameras);

                  try {
                    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                      _e9 = _step7.value;
                      _e9._checked && i.push(_e9);
                    }
                  } catch (err) {
                    _iterator7.e(err);
                  } finally {
                    _iterator7.f();
                  }
                }

                for (_s = 0; _s < e.length; _s++) {
                  _o = void 0, n = e[_s];

                  if ("videoinput" == n.kind) {
                    _iterator8 = _createForOfIteratorHelper(i);

                    try {
                      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                        _e10 = _step8.value;
                        n.deviceId == _e10.deviceId && (_o = _e10);
                      }
                    } catch (err) {
                      _iterator8.e(err);
                    } finally {
                      _iterator8.f();
                    }

                    _o || (_o = {}, _o.deviceId = n.deviceId, _o.label = n.label ? n.label : "camera " + _s), t.push(_o);
                  }
                }

                return _context13.abrupt("return", (this._allCameras = t, s._onLog && s._onLog("DCE: " + JSON.stringify(this._allCameras)), Promise.resolve(t)));

              case 8:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "_renderSelCameraInfo",
    value: function _renderSelCameraInfo() {
      if (this._selCam && (this._selCam.innerHTML = ""), this._selCam) {
        var _e11;

        var _iterator9 = _createForOfIteratorHelper(this._allCameras),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var _t6 = _step9.value;

            var _i6 = document.createElement("option");

            _i6.value = _t6.deviceId, _i6.innerText = _t6.label, this._selCam.append(_i6), _t6.deviceId && this._currentCamera && this._currentCamera.deviceId == _t6.deviceId && (_e11 = _i6);
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }

        this._selCam.value = _e11 ? _e11.value : "";
      }
    }
  }, {
    key: "getSelectedCamera",
    value: function getSelectedCamera() {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", this._currentCamera);

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "selectCamera",
    value: function selectCamera(t) {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.play(t.deviceId || t);

              case 2:
                return _context15.abrupt("return", _context15.sent);

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "getResolution",
    value: function getResolution() {
      return this._isOpen ? [this._video.videoWidth, this._video.videoHeight] : null;
    }
  }, {
    key: "setResolution",
    value: function setResolution(t, i) {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var e, s;
        return _regeneratorRuntime.wrap(function _callee15$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (!this._isOpen) {
                  _context16.next = 7;
                  break;
                }

                t instanceof Array ? (e = t[0], s = t[1]) : (e = t, s = i);
                _context16.next = 4;
                return this.play(null, e, s);

              case 4:
                _context16.t0 = _context16.sent;
                _context16.next = 10;
                break;

              case 7:
                _context16.next = 9;
                return Promise.reject(new Error("The camera is not open."));

              case 9:
                _context16.t0 = _context16.sent;

              case 10:
                return _context16.abrupt("return", _context16.t0);

              case 11:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "getVideoSettings",
    value: function getVideoSettings() {
      return JSON.parse(JSON.stringify(this.videoSettings));
    }
  }, {
    key: "updateVideoSettings",
    value: function updateVideoSettings(e) {
      return this.videoSettings = JSON.parse(JSON.stringify(e)), this._lastDeviceId = null, this._isOpen ? this.play() : Promise.resolve();
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return this._isOpen;
    }
  }, {
    key: "getCapabilities",
    value: function getCapabilities() {
      return this._assertOpen(), this._videoTrack.getCapabilities ? this._videoTrack.getCapabilities() : {};
    }
  }, {
    key: "getCameraSettings",
    value: function getCameraSettings() {
      return this._assertOpen(), this._videoTrack.getSettings();
    }
  }, {
    key: "getConstraints",
    value: function getConstraints() {
      return this._assertOpen(), this._videoTrack.getConstraints();
    }
  }, {
    key: "applyConstraints",
    value: function applyConstraints(t) {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (!(this._assertOpen(), !this._videoTrack.applyConstraints)) {
                  _context17.next = 2;
                  break;
                }

                throw Error("Not supported.");

              case 2:
                _context17.next = 4;
                return this._videoTrack.applyConstraints(t);

              case 4:
                return _context17.abrupt("return", _context17.sent);

              case 5:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "turnOnTorch",
    value: function turnOnTorch() {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (!(this._assertOpen(), this.getCapabilities().torch)) {
                  _context18.next = 4;
                  break;
                }

                _context18.next = 3;
                return this._videoTrack.applyConstraints({
                  advanced: [{
                    torch: !0
                  }]
                });

              case 3:
                return _context18.abrupt("return", _context18.sent);

              case 4:
                throw Error("Not supported.");

              case 5:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "turnOffTorch",
    value: function turnOffTorch() {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        return _regeneratorRuntime.wrap(function _callee18$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                if (!(this._assertOpen(), this.getCapabilities().torch)) {
                  _context19.next = 4;
                  break;
                }

                _context19.next = 3;
                return this._videoTrack.applyConstraints({
                  advanced: [{
                    torch: !1
                  }]
                });

              case 3:
                return _context19.abrupt("return", _context19.sent);

              case 4:
                throw Error("Not supported.");

              case 5:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "setColorTemperature",
    value: function setColorTemperature(t) {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var e;
        return _regeneratorRuntime.wrap(function _callee19$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                this._assertOpen();

                e = this.getCapabilities().colorTemperature;

                if (e) {
                  _context20.next = 4;
                  break;
                }

                throw Error("Not supported.");

              case 4:
                t < e.min ? t = e.min : t > e.max && (t = e.max);
                _context20.next = 7;
                return this._videoTrack.applyConstraints({
                  advanced: [{
                    colorTemperature: t
                  }]
                });

              case 7:
                return _context20.abrupt("return", _context20.sent);

              case 8:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee19, this);
      }));
    }
  }, {
    key: "setExposureCompensation",
    value: function setExposureCompensation(t) {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var e;
        return _regeneratorRuntime.wrap(function _callee20$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                this._assertOpen();

                e = this.getCapabilities().exposureCompensation;

                if (e) {
                  _context21.next = 4;
                  break;
                }

                throw Error("Not supported.");

              case 4:
                t < e.min ? t = e.min : t > e.max && (t = e.max);
                _context21.next = 7;
                return this._videoTrack.applyConstraints({
                  advanced: [{
                    exposureCompensation: t
                  }]
                });

              case 7:
                return _context21.abrupt("return", _context21.sent);

              case 8:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee20, this);
      }));
    }
  }, {
    key: "setZoom",
    value: function setZoom(t) {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var e;
        return _regeneratorRuntime.wrap(function _callee21$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                this._assertOpen();

                e = this.getCapabilities().zoom;

                if (e) {
                  _context22.next = 4;
                  break;
                }

                throw Error("Not supported.");

              case 4:
                t < e.min ? t = e.min : t > e.max && (t = e.max);
                _context22.next = 7;
                return this._videoTrack.applyConstraints({
                  advanced: [{
                    zoom: t
                  }]
                });

              case 7:
                return _context22.abrupt("return", _context22.sent);

              case 8:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee21, this);
      }));
    }
  }, {
    key: "setFrameRate",
    value: function setFrameRate(t) {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        var e;
        return _regeneratorRuntime.wrap(function _callee22$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                this._assertOpen();

                e = this.getCapabilities().frameRate;

                if (e) {
                  _context23.next = 4;
                  break;
                }

                throw Error("Not supported.");

              case 4:
                t < e.min ? t = e.min : t > e.max && (t = e.max);
                _context23.next = 7;
                return this._videoTrack.applyConstraints({
                  width: {
                    ideal: Math.max(this._video.videoWidth, this._video.videoHeight)
                  },
                  frameRate: t
                });

              case 7:
                return _context23.abrupt("return", _context23.sent);

              case 8:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee22, this);
      }));
    }
  }, {
    key: "getFrameRate",
    value: function getFrameRate() {
      return this.getCameraSettings().frameRate;
    }
  }, {
    key: "getFrame",
    value: function getFrame(e) {
      if (this.bDestroyed) throw Error("The DCE instance has been destroyed.");
      this._assertOpen(), s._onLog && s._onLog("DCE: getFrame(region?)");
      var t = Date.now(),
          i = this._video.videoWidth,
          o = this._video.videoHeight,
          n = Math.max(i, o);
      var r, a;

      if (n > this._canvasMaxWH) {
        var _e12 = this._canvasMaxWH / n;

        r = Math.round(i * _e12), a = Math.round(o * _e12);
      } else r = i, a = o;

      var h = 0,
          d = 0,
          l = i,
          g = o,
          c = i,
          u = o;

      if (e) {
        var _t7, _s2, _n, _2;

        e.regionMeasuredByPercentage ? (_t7 = e.regionLeft * r / 100, _s2 = e.regionTop * a / 100, _n = e.regionRight * r / 100, _2 = e.regionBottom * a / 100) : (_t7 = e.regionLeft, _s2 = e.regionTop, _n = e.regionRight, _2 = e.regionBottom), c = _n - _t7, l = Math.round(c / r * i), u = _2 - _s2, g = Math.round(u / a * o), h = Math.round(_t7 / r * i), d = Math.round(_s2 / a * o);
      }

      var _ = 0 == h && 0 == d && i == l && o == g && i == c && o == u;

      if (!this.bSaveOriCanvas && _) {
        this.videoGlCvs || (this.videoGlCvs = globalThis.OffscreenCanvas ? new OffscreenCanvas(c, u) : document.createElement("canvas"));
        var _e13 = this.videoGlCvs;
        _e13.width == c && _e13.height == u || (_e13.height = u, _e13.width = c, this.videoGl && this.videoGl.viewport(0, 0, c, u));

        var _i7 = this.videoGl || _e13.getContext("webgl", {
          alpha: !1,
          antialias: !1,
          depth: !1,
          stencil: !1,
          preserveDrawingBuffer: !0
        }) || _e13.getContext("experimental-webgl", {
          alpha: !1,
          antialias: !1,
          depth: !1,
          stencil: !1,
          preserveDrawingBuffer: !0
        });

        if (!this.videoGl) {
          this.videoGl = _i7;

          var _e14 = _i7.createShader(_i7.VERTEX_SHADER);

          _i7.shaderSource(_e14, "\nattribute vec4 a_position;\nattribute vec2 a_uv;\n\nvarying vec2 v_uv;\n\nvoid main() {\n    gl_Position = a_position;\n    v_uv = a_uv;\n}\n"), _i7.compileShader(_e14), _i7.getShaderParameter(_e14, _i7.COMPILE_STATUS) || console.error("An error occurred compiling the shaders: " + _i7.getShaderInfoLog(_e14));

          var _t8 = _i7.createShader(_i7.FRAGMENT_SHADER);

          _i7.shaderSource(_t8, "\nprecision lowp float;\n\nvarying vec2 v_uv;\n\nuniform sampler2D u_texture;\n\nvoid main() {\n    vec4 sample =  texture2D(u_texture, v_uv);\n    float grey = 0.299 * sample.r + 0.587 * sample.g + 0.114 * sample.b;\n    gl_FragColor = vec4(grey, 0.0, 0.0, 1.0);\n}\n"), _i7.compileShader(_t8), _i7.getShaderParameter(_t8, _i7.COMPILE_STATUS) || console.error("An error occurred compiling the shaders: " + _i7.getShaderInfoLog(_t8));

          var _s3 = _i7.createProgram();

          _i7.attachShader(_s3, _e14), _i7.attachShader(_s3, _t8), _i7.linkProgram(_s3), _i7.getProgramParameter(_s3, _i7.LINK_STATUS) || console.error("Unable to initialize the shader program: " + _i7.getProgramInfoLog(_s3)), _i7.useProgram(_s3), _i7.bindBuffer(_i7.ARRAY_BUFFER, _i7.createBuffer()), _i7.bufferData(_i7.ARRAY_BUFFER, new Float32Array([-1, 1, 0, 1, 1, 1, 1, 1, -1, -1, 0, 0, 1, -1, 1, 0]), _i7.STATIC_DRAW);

          var _o3 = _i7.getAttribLocation(_s3, "a_position");

          _i7.enableVertexAttribArray(_o3), _i7.vertexAttribPointer(_o3, 2, _i7.FLOAT, !1, 16, 0);

          var _n3 = _i7.getAttribLocation(_s3, "a_uv");

          _i7.enableVertexAttribArray(_n3), _i7.vertexAttribPointer(_n3, 2, _i7.FLOAT, !1, 16, 8), _i7.activeTexture(_i7.TEXTURE0), _i7.bindTexture(_i7.TEXTURE_2D, _i7.createTexture()), _i7.texParameteri(_i7.TEXTURE_2D, _i7.TEXTURE_WRAP_S, _i7.CLAMP_TO_EDGE), _i7.texParameteri(_i7.TEXTURE_2D, _i7.TEXTURE_WRAP_T, _i7.CLAMP_TO_EDGE), _i7.texParameteri(_i7.TEXTURE_2D, _i7.TEXTURE_MIN_FILTER, _i7.NEAREST), _i7.texParameteri(_i7.TEXTURE_2D, _i7.TEXTURE_MAG_FILTER, _i7.NEAREST), _i7.uniform1i(_i7.getUniformLocation(_s3, "u_texture"), 0);
        }

        (!this.glImgData || this.glImgData.length < c * u * 4) && (this.glImgData = new Uint8Array(c * u * 4)), _i7.texImage2D(_i7.TEXTURE_2D, 0, _i7.RGBA, _i7.RGBA, _i7.UNSIGNED_BYTE, this._video);

        var _o2 = s._onLog ? Date.now() : 0;

        _i7.drawArrays(_i7.TRIANGLE_STRIP, 0, 4), s._onLog && s._onLog("DCE: Grey cost: " + (Date.now() - _o2));
        var _n2 = this.glImgData;

        _i7.readPixels(0, 0, _i7.drawingBufferWidth, _i7.drawingBufferHeight, _i7.RGBA, _i7.UNSIGNED_BYTE, _n2);

        var _r = s._onLog ? Date.now() : 0,
            _a = new Uint8Array(new Uint32Array(_n2.buffer));

        s._onLog && s._onLog("DCE: Extract grey cost: " + (Date.now() - _r));

        var _h = Date.now();

        return {
          canvas: null,
          data: _a,
          region: null,
          sx: 0,
          sy: 0,
          width: c,
          height: u,
          timeSpent: _h - t,
          timeStamp: _h
        };
      }

      {
        var _i8 = null;
        if (this.bSaveOriCanvas) _i8 = document.createElement("canvas"), _i8.width = c, _i8.height = u, _i8.dbrCtx2d = _i8.getContext("2d");else {
          var _iterator10 = _createForOfIteratorHelper(this.videoCvses),
              _step10;

          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var _e15 = _step10.value;

              if (_e15.width == c && _e15.height == u) {
                _i8 = _e15;
                break;
              }
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }

          _i8 || (globalThis.OffscreenCanvas ? _i8 = new OffscreenCanvas(c, u) : (_i8 = document.createElement("canvas"), _i8.width = c, _i8.height = u), _i8.dbrCtx2d = _i8.getContext("2d"), this.videoCvses.length >= this.maxVideoCvsLength && (this.videoCvses = this.videoCvses.slice(1)), this.videoCvses.push(_i8));
        }
        var _s4 = _i8.dbrCtx2d;
        _ ? _s4.drawImage(this._video, 0, 0) : _s4.drawImage(this._video, h, d, l, g, 0, 0, c, u);

        var _o4 = _i8.dbrCtx2d || _i8.getContext("2d");

        if (0 === _i8.width || 0 === _i8.height) return null;

        var _n4 = _o4.getImageData(0, 0, _i8.width, _i8.height).data;

        var _r2 = Date.now();

        return {
          data: _n4,
          canvas: _i8,
          region: e,
          sx: h,
          sy: d,
          width: l,
          height: g,
          timeSpent: _r2 - t,
          timeStamp: _r2
        };
      }
    }
  }, {
    key: "getCurrentRegion",
    value: function getCurrentRegion() {
      var e;
      if (this._region) {
        if (this._region instanceof Array) {
          if (this.bChangeRegionIndexManually) {
            if (this._regionIndex >= this._region.length) throw new Error("the 'regionIndex' should be less than the length of region array.");
          } else ++this._regionIndex >= this._region.length && (this._regionIndex = 0);

          e = this._region[this._regionIndex];
        } else e = this._region;
      } else e = null;
      return e;
    }
  }, {
    key: "_fetchingLoop",
    value: function _fetchingLoop(e) {
      var _this5 = this;

      if (this.bDestroyed) return void this.stopFetchingLoop();
      if (!this._isOpen || !this.isFetchingLoopStarted()) return void this.stopFetchingLoop();
      if (this._video.paused) return s._onLog && s._onLog("DCE: Video is paused. Ask in 1s."), this._frameLoopTimeoutId && clearTimeout(this._frameLoopTimeoutId), void (this._frameLoopTimeoutId = setTimeout(function () {
        _this5._fetchingLoop(!0);
      }, 1e3));

      var t = function t() {
        s._onLog && s._onLog("DCE: start fetching a frame: " + Date.now());

        var e = _this5.getCurrentRegion(),
            t = _this5.getFrame(e);

        _this5._frameQueue && _this5._frameQueue.length >= _this5._frameQueueMaxLength && _this5._frameQueue.shift(), _this5._frameQueue.push(t), s._onLog && s._onLog("DCE: finish fetching a frame: " + Date.now());
      },
          i = function i() {
        _this5._frameLoopTimeoutId2 && clearTimeout(_this5._frameLoopTimeoutId2), _this5._bufferRefreshInterval <= 0 || (_this5._frameLoopTimeoutId2 = setTimeout(function () {
          _this5.bDestroyed ? _this5.stopFetchingLoop() : _this5._isOpen && _this5.isFetchingLoopStarted() ? _this5._video.paused ? _this5._frameLoopTimeoutId && clearTimeout(_this5._frameLoopTimeoutId) : (s._onLog && s._onLog("DCE: second timeout executes: " + Date.now()), t(), i()) : _this5.stopFetchingLoop();
        }, _this5._bufferRefreshInterval));
      };

      e && (this._frameQueue.length < this._frameQueueMaxLength ? (t(), i()) : this.alwaysRefreshBuffer && t()), this._frameLoopTimeoutId && clearTimeout(this._frameLoopTimeoutId), this._frameLoopTimeoutId = setTimeout(function () {
        _this5._fetchingLoop(!0);
      }, this._loopInterval);
    }
  }, {
    key: "startFetchingLoop",
    value: function startFetchingLoop() {
      if (this.bDestroyed) throw Error("The DCE instance has been destroyed.");
      if (this._assertOpen(), this._video.paused) throw Error("The video is paused.");
      this.isFetchingLoopStarted() || (this._bFetchingLoopStarted = !0, s._onLog && s._onLog("start fetching loop: " + Date.now()), this._fetchingLoop(!0));
    }
  }, {
    key: "isFetchingLoopStarted",
    value: function isFetchingLoopStarted() {
      return this._bFetchingLoopStarted;
    }
  }, {
    key: "stopFetchingLoop",
    value: function stopFetchingLoop() {
      this._bFetchingLoopStarted && (s._onLog && s._onLog("stop fetching loop: " + Date.now()), this._frameLoopTimeoutId && clearTimeout(this._frameLoopTimeoutId), this._frameQueue.length = 0, this._bFetchingLoopStarted = !1);
    }
  }, {
    key: "getFrameFromBuffer",
    value: function getFrameFromBuffer(e) {
      return this._frameQueue && this._frameQueue.length ? e ? e < this._frameQueue.length ? (this._frameLoopTimeoutId2 && clearTimeout(this._frameLoopTimeoutId2), this._frameQueue.splice(e, 1)[0]) : void 0 : (this._frameLoopTimeoutId2 && clearTimeout(this._frameLoopTimeoutId2), this._frameQueue.shift()) : null;
    }
  }, {
    key: "getQueueLength",
    value: function getQueueLength() {
      return this._frameQueue.length;
    }
  }, {
    key: "singleFrameMode",
    get: function get() {
      return this._singleFrameMode;
    },
    set: function set(e) {
      if (this._isOpen) throw new Error("`singleFrameMode` is not allowed to change when camera is open.");
      this._singleFrameMode = e;
    }
  }, {
    key: "ifSaveOriginalImageInACanvas",
    get: function get() {
      return this.bSaveOriCanvas;
    },
    set: function set(e) {
      this.bSaveOriCanvas = e;
    }
  }, {
    key: "video",
    get: function get() {
      return this._video;
    }
  }, {
    key: "region",
    set: function set(e) {
      this._region = e, this._bFetchingLoopStarted && (this._regionIndex = -1, this._fetchingLoop(!1));
    },
    get: function get() {
      return this._region;
    }
  }, {
    key: "regionIndex",
    set: function set(e) {
      this.bChangeRegionIndexManually && (this._region instanceof Array && this._region.length > e ? this._regionIndex = e : this._regionIndex = 0);
    },
    get: function get() {
      return this._regionIndex;
    }
  }, {
    key: "loopInterval",
    set: function set(e) {
      e >= 0 && (this._loopInterval = e), this._bFetchingLoopStarted && this._fetchingLoop(!1);
    },
    get: function get() {
      return this._loopInterval;
    }
  }, {
    key: "frameQueueMaxLength",
    set: function set(e) {
      for (this._frameQueueMaxLength = e; this._frameQueue && this._frameQueue.length > this._frameQueueMaxLength;) {
        this._frameQueue.shift();
      }
    },
    get: function get() {
      return this._frameQueueMaxLength;
    }
  }, {
    key: "frameQueue",
    get: function get() {
      return JSON.parse(JSON.stringify(this._frameQueue));
    }
  }, {
    key: "bufferRefreshInterval",
    set: function set(e) {
      this._bufferRefreshInterval = e;
    },
    get: function get() {
      return this._bufferRefreshInterval;
    }
  }], [{
    key: "getVersion",
    value: function getVersion() {
      return this._version;
    }
  }, {
    key: "detectEnvironment",
    value: function detectEnvironment() {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        var e;
        return _regeneratorRuntime.wrap(function _callee23$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                e = {
                  wasm: "undefined" != typeof WebAssembly && ("undefined" == typeof navigator || !(/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && /\(.+\s11_2_([2-6]).*\)/.test(navigator.userAgent))),
                  worker: !!(t ? process.version >= "v12" : "undefined" != typeof Worker),
                  getUserMedia: !("undefined" == typeof navigator || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia),
                  camera: !1,
                  browser: this.browserInfo.browser,
                  version: this.browserInfo.version,
                  OS: this.browserInfo.OS
                };

                if (!e.getUserMedia) {
                  _context24.next = 11;
                  break;
                }

                _context24.prev = 2;
                _context24.next = 5;
                return navigator.mediaDevices.getUserMedia({
                  video: !0
                });

              case 5:
                _context24.sent.getTracks().forEach(function (e) {
                  e.stop();
                });

                e.camera = !0;
                _context24.next = 11;
                break;

              case 9:
                _context24.prev = 9;
                _context24.t0 = _context24["catch"](2);

              case 11:
                return _context24.abrupt("return", e);

              case 12:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee23, this, [[2, 9]]);
      }));
    }
  }, {
    key: "createInstance",
    value: function createInstance(i) {
      return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        var e, _t9;

        return _regeneratorRuntime.wrap(function _callee24$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                if (!t) {
                  _context25.next = 2;
                  break;
                }

                throw new Error("`CameraEnhancer` is not supported in Node.js.");

              case 2:
                e = new s();
                ("string" == typeof i || i instanceof String) && (i = JSON.parse(i));

                for (_t9 in i) {
                  e[_t9] = i[_t9];
                }

                _context25.next = 7;
                return e.setUIElement(this.defaultUIElementURL);

              case 7:
                this._hasEngineResourceLoaded = !0;
                document.addEventListener("visibilitychange", e._ev_documentHideEvent);
                return _context25.abrupt("return", e);

              case 10:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee24, this);
      }));
    }
  }, {
    key: "engineResourcePath",
    get: function get() {
      return this._engineResourcePath;
    },
    set: function set(e) {
      if (this._hasEngineResourceLoaded) throw new Error("`engineResourcePath` is not allowed to change after `createInstance` is called.");
      if (null == e && (e = "./"), t || i) s._engineResourcePath = e;else {
        var _t10 = document.createElement("a");

        _t10.href = e, s._engineResourcePath = _t10.href;
      }
      this._engineResourcePath.endsWith("/") || (s._engineResourcePath += "/");
    }
  }, {
    key: "defaultUIElementURL",
    get: function get() {
      var e;
      return null === (e = this._defaultUIElementURL) || void 0 === e ? void 0 : e.replace("@engineResourcePath/", s.engineResourcePath);
    },
    set: function set(e) {
      this._defaultUIElementURL = e;
    }
  }]);

  return s;
}();

s._jsVersion = "2.0.3", s._jsEditVersion = "20210628", s._version = "JS " + s._jsVersion + "." + s._jsEditVersion, s.browserInfo = function () {
  if (!t && !i) {
    var e = {
      init: function init() {
        this.browser = this.searchString(this.dataBrowser) || "unknownBrowser", this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "unknownVersion", this.OS = this.searchString(this.dataOS) || "unknownOS", "Linux" == this.OS && -1 != navigator.userAgent.indexOf("Windows NT") && (this.OS = "HarmonyOS");
      },
      searchString: function searchString(e) {
        for (var t = 0; t < e.length; t++) {
          var i = e[t].string,
              s = e[t].prop;

          if (this.versionSearchString = e[t].versionSearch || e[t].identity, i) {
            if (-1 != i.indexOf(e[t].subString)) return e[t].identity;
          } else if (s) return e[t].identity;
        }
      },
      searchVersion: function searchVersion(e) {
        var t = e.indexOf(this.versionSearchString);
        if (-1 != t) return parseFloat(e.substring(t + this.versionSearchString.length + 1));
      },
      dataBrowser: [{
        string: navigator.userAgent,
        subString: "Edge",
        identity: "Edge"
      }, {
        string: navigator.userAgent,
        subString: "OPR",
        identity: "OPR"
      }, {
        string: navigator.userAgent,
        subString: "Chrome",
        identity: "Chrome"
      }, {
        string: navigator.vendor,
        subString: "Apple",
        identity: "Safari",
        versionSearch: "Version"
      }, {
        string: navigator.userAgent,
        subString: "Firefox",
        identity: "Firefox"
      }, {
        string: navigator.userAgent,
        subString: "MSIE",
        identity: "Explorer",
        versionSearch: "MSIE"
      }],
      dataOS: [{
        string: navigator.userAgent,
        subString: "HarmonyOS",
        identity: "HarmonyOS"
      }, {
        string: navigator.userAgent,
        subString: "Android",
        identity: "Android"
      }, {
        string: navigator.userAgent,
        subString: "iPhone",
        identity: "iPhone"
      }, {
        string: navigator.platform,
        subString: "Win",
        identity: "Windows"
      }, {
        string: navigator.platform,
        subString: "Mac",
        identity: "Mac"
      }, {
        string: navigator.platform,
        subString: "Linux",
        identity: "Linux"
      }]
    };
    return e.init(), {
      browser: e.browser,
      version: e.version,
      OS: e.OS
    };
  }

  if (i) return {
    browser: "ssr",
    version: 0,
    OS: "ssr"
  };
}(), s._hasEngineResourceLoaded = !1, s._engineResourcePath = function () {
  if (t) return "";

  if (!i && document.currentScript) {
    var e = document.currentScript.src,
        _t11 = e.indexOf("?");

    if (-1 != _t11) e = e.substring(0, _t11);else {
      var _t12 = e.indexOf("#");

      -1 != _t12 && (e = e.substring(0, _t12));
    }
    return e.substring(0, e.lastIndexOf("/") + 1);
  }

  return "./";
}(), s._defaultUIElementURL = "@engineResourcePath/dce.ui.html";

var o = /*#__PURE__*/function () {
  function o() {
    _classCallCheck(this, o);
  }

  _createClass(o, null, [{
    key: "getVersion",
    value: function getVersion() {
      return s.getVersion();
    }
  }, {
    key: "detectEnvironment",
    value: function detectEnvironment() {
      return s.detectEnvironment();
    }
  }, {
    key: "browserInfo",
    get: function get() {
      return s.browserInfo;
    }
  }, {
    key: "engineResourcePath",
    get: function get() {
      return s.engineResourcePath;
    },
    set: function set(e) {
      s.engineResourcePath = e;
    }
  }, {
    key: "_onLog",
    get: function get() {
      return s._onLog;
    },
    set: function set(e) {
      s._onLog = e;
    }
  }]);

  return o;
}();

o.CameraEnhancer = s;
export { s as CameraEnhancer, o as DCE, o as default };